export default __webpack_public_path__ + "static/media/selected-option-marker.129335ad.svg";